import { Fragment } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import ClaimTypes from "./pages/ClaimTypes";
import Dashboard from "./pages/Dashboard";
import LawFirms from "./pages/LawFirms";
import Payments from "./pages/Payments";
// import AddCase from "./pages/AddCase";
import CaseDetails from "@/pages/CaseDetails";
import CasesDashboard from "@/pages/CasesDashboard";
import PaymentTypes from "@/pages/PaymentTypes";
import MobileSidebar from "./MobileSidebar";
import Sidebar from "./Sidebar";
import ActionTypes from "./pages/ActionTypes";
import AddActions from "./pages/AddActions";
import AddPayments from "./pages/AddPayments";
import CaseDetail from "./pages/CaseDetail";
import Designation from "./pages/Designation";
import Designations from "./pages/Designations";
import Insurer from "./pages/Insurer";
import Insurers from "./pages/Insurers";
import Platform from "./pages/Platform";
import Platforms from "./pages/Platforms";
import Reporter from "./pages/Reporter";
import Reporters from "./pages/Reporters";
import Town from "./pages/Town";
import Towns from "./pages/Towns";

const RouteComponent = () => {
	return (
		<main className="bg-backgroundLight">
			<Router>
				<Fragment>
					{/* <Routes>
                    <Route path="/" component={Login} />
                    </Routes>    */}
					{/* <Navbar /> */}
					{/* <Header /> */}
					<Sidebar />
					<div className="lg:ml-[300px] grow">
						<div className="block lg:hidden bg-white px-4 py-2 border-b border-zinc-200 shadow-sm sticky top-0 z-10">
							<MobileSidebar />
						</div>
						<div className="py-8 px-4">
							<Routes>
								<Fragment>
									<Route path="/" element={<CasesDashboard />}></Route>
									<Route path="/old" element={<Dashboard />}></Route>
									<Route path="/claim-types" element={<ClaimTypes />}></Route>
									<Route path="/event-types" element={<ActionTypes />}></Route>
									<Route path="/payment-types" element={<PaymentTypes />}></Route>
									<Route path="/law-firms" element={<LawFirms />}></Route>
									<Route path="/insurers" element={<Insurers />}></Route>
									<Route path="/insurer/:id" element={<Insurer />}></Route>
									<Route path="/designations" element={<Designations />}></Route>
									<Route path="/designation/:id" element={<Designation />}></Route>
									<Route path="/reporters" element={<Reporters />}></Route>
									<Route path="/reporter/:id" element={<Reporter />}></Route>
									<Route path="/platforms" element={<Platforms />}></Route>
									<Route path="/platform/:id" element={<Platform />}></Route>
									<Route path="/towns" element={<Towns />}></Route>
									<Route path="/town/:id" element={<Town />}></Route>
									<Route path="/payments" element={<Payments />}></Route>
									{/* <Route path="/addcase" element={<AddCase/>}></Route> */}
									<Route path="/casedetail" element={<CaseDetail />}></Route>
									<Route path="/case/:id" element={<CaseDetails />}></Route>
									<Route path="/addactions" element={<AddActions />}></Route>
									<Route path="/addpayments" element={<AddPayments />}></Route>
								</Fragment>
							</Routes>
						</div>
					</div>
				</Fragment>
			</Router>
		</main>
	);
};

export default RouteComponent;
